import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import OverrideServerPropertiesIntro from './override-server-properties-intro.mdx';
import OverrideGeoIPPropertiesIntro from './override-geoip-properties-intro.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <OverrideServerPropertiesIntro mdxType="OverrideServerPropertiesIntro" />
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-shell"
        }}>{`curl -v -L --header "Content-Type: application/json" -d '  {
    "api_key": "<ph_project_api_key>",
    "distinct_id": "distinct_id_of_your_user",
    "groups" : { # Required only for group-based feature flags
      "group_type": "group_id" # Replace "group_type" with the name of your group type. Replace "group_id" with the id of your group.
    },
    "person_properties": {"<personProp1>": "<personVal1>"}, # Optional. Include any properties used to calculate the value of the feature flag.
    "group_properties": {"group type": {"<groupProp1>":"<groupVal1>"}} # Optional. Include any properties used to calculate the value of the feature flag.
}' <ph_client_api_host>/flags?v=2
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`import requests
import json

url = "<ph_client_api_host>/flags?v=2"
headers = {
    "Content-Type": "application/json"
}
payload = {
    "api_key": "<ph_project_api_key>",
    "distinct_id": "distinct_id_of_your_user",
    "groups" : { # Required only for group-based feature flags
      "group_type": "group_id" # Replace "group_type" with the name of your group type. Replace "group_id" with the id of your group.
    },
    "person_properties": {"<personProp1>": "<personVal1>"}, # Optional. Include any properties used to calculate the value of the feature flag.
    "group_properties": {"group type": {"<groupProp1>":"<groupVal1>"}} # Optional. Include any properties used to calculate the value of the feature flag.
}
response = requests.post(url, headers=headers, data=json.dumps(payload))
print(response.json())
`}</code></pre>
    </MultiLanguage>

    <OverrideGeoIPPropertiesIntro mdxType="OverrideGeoIPPropertiesIntro" />
    <p>{`To override the GeoIP properties used to evaluate a feature flag, provide an IP address in the `}<inlineCode parentName="p">{`HTTP_X_FORWARDED_FOR`}</inlineCode>{` when making your `}<inlineCode parentName="p">{`/flags`}</inlineCode>{` request:`}</p>
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-shell"
        }}>{`curl -v -L \\
--header "Content-Type: application/json" \\
--header "HTTP_X_FORWARDED_FOR: the_client_ip_address_to_use " \\
-d '  {
    "api_key": "<ph_project_api_key>",
    "distinct_id": "distinct_id_of_your_user"
}' <ph_client_api_host>/flags?v=2
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`import requests
import json

url = "<ph_client_api_host>/flags?v=2"
headers = {
    "Content-Type": "application/json",
    "HTTP_X_FORWARDED_FOR": "the_client_ip_address_to_use"
}
payload = {
    "api_key": "<ph_project_api_key>",
    "distinct_id": "distinct_id_of_your_user"
}
response = requests.post(url, headers=headers, data=json.dumps(payload))
print(response.json())
`}</code></pre>
    </MultiLanguage>
    <p>{`The list of properties that this overrides:`}</p>
    <ol>
      <li parentName="ol"><inlineCode parentName="li">{`$geoip_city_name`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`$geoip_country_name`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`$geoip_country_code`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`$geoip_continent_name`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`$geoip_continent_code`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`$geoip_postal_code`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`$geoip_time_zone`}</inlineCode></li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      